import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface OpenRiqueOptions {
  prompt?: string;
  companyId?: string;
}

export interface RiqueScreenScope {
  companyId: string;
  dataFrom: string;
  dataTo: string;
  compareFrom: string;
  compareTo: string;
}

const emptyScreenScope = (): RiqueScreenScope => ({
  companyId: '',
  dataFrom: '',
  dataTo: '',
  compareFrom: '',
  compareTo: '',
});

interface RiqueChatState {
  pendingPrompt: string | null;
  companyId: string;
  pageContext: string;
  routePath: string;
  screenScope: RiqueScreenScope;
}

interface RiqueChatActions {
  /** Prepara prompt/empresa; a navegação para `/rique` fica a cargo do caller. */
  openRique: (options?: OpenRiqueOptions) => void;
  setPendingPrompt: (prompt: string | null) => void;
  setCompanyId: (companyId: string) => void;
  setPageContext: (pageContext: string) => void;
  setRoutePath: (routePath: string) => void;
  setScreenScope: (scope: RiqueScreenScope) => void;
  consumePendingPrompt: () => string | null;
}

export const useRiqueChatStore = create<RiqueChatState & RiqueChatActions>()(
  persist(
    (set, get) => ({
      pendingPrompt: null,
      companyId: '',
      pageContext: '',
      routePath: '',
      screenScope: emptyScreenScope(),

      openRique: (options) => {
        set({
          pendingPrompt: options?.prompt?.trim() || null,
          companyId: options?.companyId ?? get().companyId,
        });
      },

      setPendingPrompt: (pendingPrompt) => set({ pendingPrompt }),

      setCompanyId: (companyId) => set({ companyId }),

      setPageContext: (pageContext) => set({ pageContext }),

      setRoutePath: (routePath) => set({ routePath }),

      setScreenScope: (screenScope) => set({ screenScope }),

      consumePendingPrompt: () => {
        const prompt = get().pendingPrompt;
        if (prompt) set({ pendingPrompt: null });
        return prompt;
      },
    }),
    {
      name: 'rique-chat-ui',
      partialize: (s) => ({ companyId: s.companyId }),
    }
  )
);
